import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const AuthenticatedRoute = ({ children, redirectTo = "/home" }) => {
  const { isAuthInitializing, isAuthenticated } = useContext(AuthContext);

  if (isAuthInitializing) return null;
  if (!isAuthenticated()) return <Navigate to={redirectTo} replace />;

  return children;
};

export default AuthenticatedRoute;
